import React from 'react';
import PropTypes from 'prop-types';
import PhotoGallery from './PhotoGallery';

/**
 * SegmentPhotos Component
 *
 * @param litterDataForSegment array from littersBySegmentId for the specified segmentId
 */
export default function SegmentPhotos({ litterDataForSegment }) {
    const formatLittersForGallery = () => {
        if (litterDataForSegment && litterDataForSegment.length > 0) {
            const formattedLitters = litterDataForSegment.map(
                (litter, photoIndex) => {
                    return {
                        photoIndex, //used to select image in <ImageGallery/> component
                        photoUrl: litter.file,
                        classification: litter.classification
                            ? litter.classification
                            : 'LITTER',
                        imageId: litter.imageId, // If not a litter, this will be undefined.  This enables deleting a specific litter photo by imageId.
                    };
                },
            );
            return formattedLitters ? formattedLitters.flat() : [];
        } else return [];
    };

    const formatLittersForBreakdown = () => {
        if (litterDataForSegment && litterDataForSegment.length > 0) {
            return litterDataForSegment.reduce(
                (acc, curr) => {
                    if (
                        curr.classification !== 'BAGGAGE' &&
                        curr.classification !== 'COLLECTED'
                    ) {
                        switch (curr.classification) {
                            case 'SEGMENT_INTRO':
                                acc.segmentIntros += 1;
                                break;

                            case 'BIN':
                                acc.bins += 1;
                                break;

                            case 'LITTER':
                                acc.litters += 1;
                                break;

                            case 'HOTSPOT':
                                acc.hotspots += 1;
                                break;

                            default:
                                acc.litters += 1;
                                break;
                        }
                    }
                    return acc;
                },
                { segmentIntros: 0, bins: 0, litters: 0, hotspots: 0 },
            );
        } else return { segmentIntros: 0, bins: 0, litters: 0, hotspots: 0 };
    };

    return litterDataForSegment ? (
        <PhotoGallery
            photos={formatLittersForGallery()}
            photoBreakdown={formatLittersForBreakdown()}
        />
    ) : (
        <p className="p-4">No Gallery Available</p>
    );
}

SegmentPhotos.propTypes = {
    litterDataForSegment: PropTypes.array,
};
